module.exports = __webpack_public_path__ + "static/media/Subodh_College_Logo.e2c21192.jpg";